// extracted by mini-css-extract-plugin
export var filtersTaxo = "listResults-module--filters-taxo--2d2ed";
export var listResult = "listResults-module--list-result--262e7";
export var resultContent = "listResults-module--result-content--b4b41";
export var resultItem = "listResults-module--result-item--d6197";
export var resultResume = "listResults-module--result-resume--a67ec";
export var resultTitle = "listResults-module--result-title--ef885";
export var resultType = "listResults-module--result-type--6870a";
export var resultTypeIcon = "listResults-module--result-type-icon--b6b32";
export var resultTypeType = "listResults-module--result-type-type--b110b";
export var results = "listResults-module--results--f983e";
export var resultsContainer = "listResults-module--results-container--eae30";
export var resultsTop = "listResults-module--results-top--ca5bc";